import { Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import BigIcon from "../../../../ui/components/BigIcon/BigIcon";

export default function ArticleDistributeModalHeader({ state }) {
	return (
		<Header icon as="h2" textAlign="center" style={{ margin: "1em" }}>
			<ArticleDistributeModalHeaderContent state={state} />
		</Header>
	);
}

function ArticleDistributeModalHeaderContent({ state }) {
	const { t } = useTranslation();

	if (state === "noPublisher") {
		return (
			<>
				<BigIcon color="grey" name="ban" />

				{t("noPublisherSelected", "Publisher is not selected")}

				<Header.Subheader>
					{t("notSupportedFromSuperAdmin", "Batch delivery is not supported from the super admin view.")}
				</Header.Subheader>
			</>
		);
	}

	if (state === "unavailable") {
		return (
			<>
				<BigIcon color="grey" name="ban" />

				{t("noChannelsAvailable", "No channels available")}

				<Header.Subheader>
					{t("noChannelsAvailableDescription", "There are no channels available for delivery")}
				</Header.Subheader>
			</>
		);
	}

	if (state === "initial") {
		return (
			<>
				<BigIcon color="black" name="send" />

				{t("preparingDelivery", "Preparing delivery")}

				<Header.Subheader>
					{t("confirmDelivery", "Would you like to queue/schedule a delivery for the following channels")}
				</Header.Subheader>
			</>
		);
	}

	if (state === "submitting") {
		return (
			<>
				<BigIcon color="black" name="spinner" loading />

				{t("preparingDelivery", "Preparing delivery")}

				<Header.Subheader>{t("pleaseWait", "Please wait")}</Header.Subheader>
			</>
		);
	}

	if (state === "completed") {
		return (
			<>
				<BigIcon color="green" name="check" />

				{t("deliveryIsInProgress", "Delivery is in progress")}

				<Header.Subheader>{t("youCanCloseThisWindow", "You can close this window")}</Header.Subheader>
			</>
		);
	}

	if (state === "failed") {
		return (
			<>
				<BigIcon color="red" name="x" />

				{t("someDeliveriesFailed", "Some deliveries failed")}

				<Header.Subheader>{t("checkTheErrorsBelow", "Check the errors below")}</Header.Subheader>
			</>
		);
	}

	return null;
}
